import queryString from "query-string";

export const apiOrigin = process.env.NEXT_PUBLIC_API_ORIGIN;

export const httpPOST = async (route: string, body: { [key: string]: any }) => {
  return httpFetch(`${route}`, body, "POST");
};

export const httpPUT = async (route: string, body: { [key: string]: any }) => {
  return httpFetch(`${route}`, body, "PUT");
};

export const httpDELETE = async (
  route: string,
  body: { [key: string]: any }
) => {
  return httpFetch(`${route}`, body, "DELETE");
};

export const httpGET = async (
  route: string,
  body: { [key: string]: any },
  needAuth: boolean = true
) => {
  return httpFetch(
    `${route}?${queryString.stringify(body, { arrayFormat: "bracket" })}`,
    undefined,
    "GET",
    needAuth
  );
};

const httpFetch = async (
  url: string,
  body?: { [key: string]: any },
  method: "GET" | "POST" | "DELETE" | "PUT" = "GET",
  needAuth: boolean = true
) => {
  const res = await fetch(`${apiOrigin}${url}`, {
    method,
    // credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(needAuth
        ? { Authorization: `Bearer ${localStorage.getItem("accessToken")}` }
        : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const jsonRes = await res.clone().json();
  if (res.status !== 200) {
    if (res.status === 401) {
      localStorage.removeItem("accessToken");
      localStorage.setItem("forceLogin", "true");
      window.location.href = "/login";
    }
    throw jsonRes;
  }

  return jsonRes;
};
